const GOOGLE_FORM_URL = 'https://docs.google.com/forms/d/e/1FAIpQLScBB6Isrq9crpLI7Mu8To1I458TT1WPIECs7F-5KuD9DwR5Zg/viewform';

export const Footer = () => {
  return (
    <footer className="bg-white dark:bg-slate-900 border-t border-slate-200 dark:border-slate-800 py-6 mt-auto">
      <div className="max-w-[1600px] mx-auto px-6 text-center">
        <p className="text-sm text-slate-600 dark:text-slate-400">
          © {new Date().getFullYear()} Spreadsheet Poster Print
          <span className="mx-3">•</span>
          <a 
            href={GOOGLE_FORM_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#21A366] hover:text-[#1a8252] hover:underline transition-colors"
          >
            Send Feedback
          </a>
        </p>
      </div>
    </footer>
  );
};
